import { message } from "antd";
import React,{ useEffect } from "react";
export function withScroll(WrappedComponent) {
  return function (props) {
    // const location = useLocation();
    useEffect(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
      message.destroy();
    }, []);

    return <WrappedComponent {...props} />;
  };
}